<div class="pt-1">
  @if (failedEntry(); as failed) {
    <div class="mb-4 flex items-start gap-2 rounded-md border border-destructive/25 bg-destructive/5 p-3 text-destructive">
      <ng-icon name="lucideTriangleAlert" size="15" class="mt-0.5 shrink-0" />
      <div class="min-w-0 text-xs">
        <p class="font-bold">{{ failed.label }} fehlgeschlagen</p>
        @if (failed.errorCode) {
          <p class="mt-1 font-mono">{{ failed.errorCode }}</p>
        }
        @if (failed.errorDetail || failed.errorMessage) {
          <p class="mt-1 text-destructive/80">{{ failed.errorDetail || failed.errorMessage }}</p>
        }
      </div>
    </div>
  }

  <app-step-timeline
    [steps]="technicalTimelineSteps()"
    [config]="{
      orientation: 'horizontal',
      variant: 'rail',
      size: 'sm',
      showLines: true,
      showDescriptions: true,
      showTimestamps: false,
      interactive: false,
      animated: true,
    }"
    (nodeActionClick)="onTimelineNodeAction($event)"
  />

  <p class="mt-3 font-mono text-2xs text-muted-foreground">
    Aufgabe wählen, um sie zu starten, zu stoppen oder zu wiederholen
  </p>

  <div class="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 border-t pt-3 font-mono text-2xs text-muted-foreground">
    <span>Analyse {{ shortAnalysisId() }}</span>
    <span>Worker {{ workerLabel() }}</span>
    <span>Laufzeit {{ runtimeLabel() }}</span>
    <button
      type="button"
      class="ml-auto inline-flex items-center gap-1.5 font-sans text-xs font-normal text-foreground hover:text-primary disabled:pointer-events-none disabled:opacity-50"
      [disabled]="isResettingState()"
      (click)="resetStateRequested.emit()"
    >
      @if (isResettingState()) {
        <ng-icon name="lucideLoader" size="12" class="animate-spin" />
      }
      Status zurücksetzen
    </button>
  </div>
</div>
